import { isObjectRecord } from "../../typeGuards/isObjectRecord";
import { ArsTableBody } from "../interface";
import { isArsTableGroupCalculationDto } from "./isArsTableGroupCalculationDto";
import { isArsTableRowHeader } from "./isArsTableRowHeader";

/**
 * Type guard for ArsTableBody.
 *
 * @param obj - The object to check.
 * @param isT - A type guard function for the generic type T.
 * @returns True if the object is an ArsTableBody, false otherwise.
 */
export const isArsTableBody = <T = string>(
  obj: unknown,
  isT: (value: unknown) => value is T = (value: unknown): value is T => typeof value === "string",
): obj is ArsTableBody<T> => {
  // Check object
  if (!isObjectRecord(obj)) return false;

  // Check required properties
  if (typeof obj.id !== "string") return false;
  if (typeof obj.analysisMethodId !== "string") return false;
  if (
    !Array.isArray(obj.columns) ||
    obj.columns.some((col) => !isArsTableGroupCalculationDto(col, isT))
  )
    return false;
  if (!["string", "undefined"].includes(typeof obj.dataSubsetId)) return false;
  if (!Array.isArray(obj.rowHeaders) || obj.rowHeaders.some((rh) => !isArsTableRowHeader(rh, isT)))
    return false;
  if (!Array.isArray(obj.rows) || obj.rows.some((row) => !isArsTableGroupCalculationDto(row, isT)))
    return false;

  // Everything is good
  return true;
};
